import moment from "moment";

const VALID_STATUS = "VALID";
const ONLINE_STATUS = "ONLINE";

const NUM_DAYS_BEFORE_EXPIRY_WARNING = 30;

export const checkIsLicenseValidOrOnline = (licenseStatus: string): boolean =>
  licenseStatus === VALID_STATUS || licenseStatus === ONLINE_STATUS;

const isServerInLastNDaysBeforeDate = (
  nDays: number,
  targetDate: string,
  currentDate: string
): boolean => {
  const nDaysBeforeTargetDate = moment(targetDate).subtract(nDays, "days");
  return moment(currentDate).isBetween(nDaysBeforeTargetDate, targetDate);
};

export const isLicenseExpiring = (
  licenseExpiryDate: string,
  serverTime: string
): boolean =>
  isServerInLastNDaysBeforeDate(
    NUM_DAYS_BEFORE_EXPIRY_WARNING,
    licenseExpiryDate,
    serverTime
  );

export const formatExpiryDate = (expiryDateUnformatted: string) => {
  const expiryDateMoment = moment.utc(expiryDateUnformatted);
  return expiryDateUnformatted != null && expiryDateMoment.isValid()
    ? expiryDateMoment.format("YYYY-MM-DDTHH:mm:ss[Z]")
    : expiryDateUnformatted;
};
